<template>
  <section class="section pb-0">
    <div class="container-lg flex flex-col items-center gap-[12px]">
      <h1 class="m-0 text-[24px] font-semibold leading-[32px]">
        {{ splitTitle(in18['page_about_us'])?.first }}
        <span :class="['text-lime-green ']">
          {{ splitTitle(in18['page_about_us'])?.last }}
        </span>
      </h1>
      <div v-if="in18['page_description']" class="text-[16px] font-light text-medium-gray text-center">
         {{ in18['page_description'] }} 

      </div>
      <div class="w-full h-1 my-[16px] mb-[48px] border-b border-light-gray/25">
        <div class="mx-auto w-[56%] md:w-[16%] h-1" :class="['bg-lime-green ']" />
      </div>
    </div>
    <picture>
        <source :srcset="banner.image.webp" type="image/webp">
        <img
            :src="banner.image.source"
            alt="banner"
            class="mx-auto xl:rounded-[8px] max-h-[470px] object-contain lazyload"
            loading="lazy"
            width="100%"
            height="auto"
        >
    </picture>
    <div class="container-lg pt-[64px] grid grid-cols-2 lg:grid-cols-3 gap-[32px] lg:gap-[64px]">
      <div class="col-span-2 lg:col-span-1 text-[18px] font-light leading-[28px] text-justify p-[32px] lg:p-0">
        {{ in18['main_content_part_1'] }}
      </div>
      <div class="col-span-2 flex flex-col gap-[12px] p-[32px] rounded-[8px] shadow-base border border-charcoal/[7%]">
        <div class="flex flex-col sm:flex-row gap-[20px] items-center sm:items-start">
          <div>
            <svg class="size-[60px]" xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
              <rect x="0.5" y="0.5" width="59" height="59" rx="29.5" stroke="#606060"/>
              <path d="M25.9051 31.6182L27.7099 32.8315L30.0012 31.6718L32.2926 32.8315L34.0846 31.631L32.8946 29.237C32.8355 29.1172 32.746 29.02 32.6262 28.9453C32.5065 28.8707 32.3793 28.8333 32.2447 28.8333H27.7087C27.5742 28.8333 27.4505 28.8707 27.3377 28.9453C27.2257 29.02 27.1402 29.1172 27.0811 29.237L25.9051 31.6182ZM22.0971 39.3333H37.8762L34.5956 32.6985L32.3766 34.1685L30.0012 32.9948L27.6259 34.1685L25.3707 32.6693L22.0971 39.3333ZM20.2188 40.5L26.0124 28.7097C26.1765 28.3954 26.411 28.1431 26.7159 27.9525C27.02 27.7619 27.3506 27.6667 27.7076 27.6667H29.4179V19.5H36.0586L35.1836 21.25L36.0586 23H30.5846V27.6667H32.2004C32.5582 27.6667 32.8841 27.7608 33.1781 27.949C33.4729 28.1372 33.7046 28.3884 33.8734 28.7027L39.7837 40.5H20.2188Z" fill="#606060"/>
            </svg>
          </div>
          <div class="flex flex-col gap-1 sm:!text-left text-center">
            <span class="text-[16px] leading-[22px] font-medium text-hot-pink "> {{in18['section_1_title']}} </span>
            <span class="text-[14px] leading-[18px] text-medium-gray">
              {{ in18['section_1_text'] }}
            </span>
          </div>
        </div>

        <div class="w-[80%] mx-auto bg-light-gray/25 h-[1px] my-4"></div>
        <div class="flex flex-col sm:flex-row gap-[20px] items-center sm:items-start">
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
              <rect x="0.5" y="0.5" width="59" height="59" rx="29.5" stroke="#606060"/>
              <path d="M18.332 25.3333C18.332 25.3333 23.5552 19.5 29.9987 19.5C36.4422 19.5 41.6654 25.3333 41.6654 25.3333" stroke="#606060" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M41.1334 31.2205C41.488 31.7175 41.6654 31.9671 41.6654 32.3346C41.6654 32.7033 41.488 32.9518 41.1334 33.4488C39.5397 35.6841 35.4692 40.5013 29.9987 40.5013C24.527 40.5013 20.4577 35.683 18.864 33.4488C18.5094 32.9518 18.332 32.7021 18.332 32.3346C18.332 31.966 18.5094 31.7175 18.864 31.2205C20.4577 28.9851 24.5282 24.168 29.9987 24.168C35.4704 24.168 39.5397 28.9863 41.1334 31.2205Z" stroke="#606060" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M33.5 32.332C33.5 31.4038 33.1313 30.5135 32.4749 29.8572C31.8185 29.2008 30.9283 28.832 30 28.832C29.0717 28.832 28.1815 29.2008 27.5251 29.8572C26.8687 30.5135 26.5 31.4038 26.5 32.332C26.5 33.2603 26.8687 34.1505 27.5251 34.8069C28.1815 35.4633 29.0717 35.832 30 35.832C30.9283 35.832 31.8185 35.4633 32.4749 34.8069C33.1313 34.1505 33.5 33.2603 33.5 32.332Z" stroke="#606060" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="flex flex-col gap-1  sm:!text-left text-center">
            <span class="text-[16px] leading-[22px] font-medium text-hot-pink "> {{ in18['section_2_title'] }} </span>
            <span class="text-[14px] leading-[18px] text-medium-gray ">
              {{ in18['section_2_text'] }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="container-lg py-[64px] grid grid-cols-2 lg:grid-cols-3 gap-[32px] lg:gap-[64px]">
      <div class="col-span-2 rounded-[8px] overflow-hidden">
        <picture>
              <source srcset="{{ smallBanner.image.webp }}" type="image/webp">
              <img class="object-cover w-full h-full lazyload" :src="smallBanner.image.source" alt="banner"/>
        </picture>
      </div>


      <div class="col-span-2 lg:col-span-1 p-[32px] lg:p-0 text-[18px] font-light leading-[28px] text-justify">
        {{ in18['main_content_part_2'] }}
      </div>
    </div>
    <div class="py-[56px] bg-off-white">
      <div class="container-lg flex flex-col items-center gap-[12px]">
        <h1 class="m-0 text-[24px] font-semibold leading-[32px]">
          {{ splitTitle('Seko mums instagram')?.first }}
          <span :class="['text-lime-green ']">
            {{ splitTitle('Seko mums instagram')?.last }}
          </span>
        </h1>
        <div class="w-full h-1 my-[16px] mb-[0px] border-b border-light-gray/25">
          <!-- <div class="mx-auto w-[56%] md:w-[16%] h-1" :class="['bg-lime-green ']" /> -->
        </div>
      </div>
      <div class="elfsight-app-a5a7e5e3-7501-4edc-8f31-8f0c800df479" data-elfsight-app-lazy></div>
    </div>
  </section>
</template>

<script setup>
import { ref, defineProps } from "vue";

const props = defineProps({
  banner: {
    type: [Object, String],
    default: "",
  },
  smallBanner: {
    type: [Object, String],
    default: "",
  },
  in18: {
    type: Object,
    required: true
  }
});

const splitTitle = (string) => {
  if (!string) return {};
  const words = string.split(" ");
  const last = words.pop();
  return {
    first: words.join(" "),
    last,
  };
};
</script>

<style lang="scss" scoped></style>
